import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiUrls } from '../../../common/api_urls/api_urls';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { headers } from '../../../common/headers';

const header = new HttpHeaders({ [headers.lookupHeader]: 'true' });

@Injectable({
  providedIn: 'root',
})
export class ReseetPasswordService {
  public http = inject(HttpClient);
  public authService = inject(AuthService);
  constructor() {}
  getEmail(): string {
    return this.authService.getSession(this.authService.emailKey);
  }
  resetPassword(data: any) {
    var bodyData = {
      username: data.email,
      confirmationCode: data.code,
      password: data.password,
    };
    return this.http
      .post(apiUrls.authentication.confirmPassword, bodyData, {
        headers: header,
      })
      .pipe(
        tap((data: any) => {
        }),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }
}
